var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.term
    ? _c("section", { staticClass: "rsp2CategoryHeader" }, [
        _c("div", {
          staticClass: "rsp2Icon",
          domProps: { innerHTML: _vm._s(_vm.term.icon) }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "rsp2Info" }, [
          _c("h2", { domProps: { innerHTML: _vm._s(_vm.term.title) } }),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.term.description))])
        ]),
        _vm._v(" "),
        _vm.news ? _c("div", { staticClass: "rsp2Arrow" }) : _vm._e(),
        _vm._v(" "),
        _vm.news
          ? _c("article", { staticClass: "rsp2News" }, [
              _c("h2", [_vm._v("Aktuell")]),
              _vm._v(" "),
              _c("h3", [
                _c(
                  "a",
                  { attrs: { href: _vm.news.url, title: _vm.news.title } },
                  [_vm._v(_vm._s(_vm.news.title))]
                )
              ]),
              _vm._v(" "),
              _c("i", [
                _vm._v(
                  "\n\t\t\tVon " +
                    _vm._s(_vm._f("fullName")(_vm.news.author)) +
                    "\n\t\t\t"
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(
                      _vm._f("prepend")(
                        _vm._f("formatDate")(_vm.news.date),
                        "am"
                      )
                    ) +
                    "\n\t\t"
                )
              ])
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }